import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import { PortfolioTransactionListModuleFactory } from '../../endpoints/portfolio/transaction/list.module.js';
import { PortfolioListModuleFactory } from '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import { PortfolioGetModuleFactory } from '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import { PortfolioTransactionDeleteModuleFactory } from '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { getEndpointOptions } from '../../helpers/common.js';

class PortfolioTransactionDeleteStoreModuleFactory extends Mdg2StoreModuleFactory {
  getResponse(payload) {
    return {
      data: {}
    };
  }
  getPortfolioTransactionDeleteRequest(payload) {
    return {
      data: {
        id: payload.id,
        transaction: {
          id: payload.transactionId
        },
        notation: {
          id: payload.securityId
        }
      }
    };
  }
  async updatePortfolioTransactionDelete(payload) {
    const request = this.getPortfolioTransactionDeleteRequest(payload);
    return this.getEndpoints().portfolioTransactionDelete.updateState(request);
  }
  getPortfolioTransactionListRequest(id) {
    return { id };
  }
  async updatePortfolioTransactionList(payload) {
    const request = this.getPortfolioTransactionListRequest(payload.id);
    return this.getEndpoints().portfolioTransactionList.updateState(request);
  }
  getPortfolioListRequest() {
    return {};
  }
  async updatePortfolioList(payload) {
    const request = this.getPortfolioListRequest();
    return this.getEndpoints().portfolioList.updateState(request);
  }
  getPortfolioGetRequest(id) {
    return { id };
  }
  async updatePortfolioGet(payload) {
    const request = this.getPortfolioGetRequest(payload.id);
    return this.getEndpoints().portfolioGet.updateState(request);
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      if (payload.action === "DELETE") {
        await this.updatePortfolioTransactionDelete(payload);
        await Promise.all([this.updatePortfolioTransactionList(payload), this.updatePortfolioList(payload), this.updatePortfolioGet(payload)]);
      }
    } catch (error) {
      this.logger.error(error);
      isResponseSuccessful = false;
    }
    return isResponseSuccessful;
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a;
    if (!this.endpoints) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      this.endpoints = {
        portfolioTransactionList: this.getModuleEntity(PortfolioTransactionListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioTransactionList")),
        portfolioGet: this.getModuleEntity(PortfolioGetModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioGet")),
        portfolioList: this.getModuleEntity(PortfolioListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioList")),
        portfolioTransactionDelete: this.getModuleEntity(PortfolioTransactionDeleteModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioTransactionDelete"))
      };
    }
    return this.endpoints;
  }
}

export { PortfolioTransactionDeleteStoreModuleFactory };
